import { zodContract } from '@leprecoins/effector-sockets';
import { createReceive } from '../clients';
import { balanceSchema } from '../types';

export const receiveBalance = createReceive('balance', zodContract(balanceSchema));
